import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Label, Card, Col } from "reactstrap";
import { useForm } from "react-hook-form";
import ApiService from "../../../services/apiService";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { updateDistributaryTitle, distributaryZone } from "../../../constants";
import Update from "../../table/Update";
const UpdateDistributary = () => {
  const navigate = useNavigate();
  const { Id } = useParams();
  const { register, handleSubmit, setValue, formState: { errors } } = useForm();
  const [data,setData] = useState<any>();
  // Fetch distributary data when component mounts

   const initialData = {
    Distributary_Zone : data?.distributary_Zone,
    TotalArea : data?.totalArea,
   }
  useEffect(() => {
    const fetchDistributary = async () => {
      try {
        const response = await ApiService.axiosApi(`/dzone/${Id}`, {
          method: 'GET',
        });

        if (response.success) {
          setData(response.data)
        } else {
          toast.error("Failed to fetch distributary details");
          navigate(-1);
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch distributary details");
        navigate(-1);
      }
    };

    if (Id) fetchDistributary();
  }, [Id, setValue, navigate]);


  const onSubmit = async (data: any) => {
    try {
      const updateData = {
        Distributary_Zone: data.Distributary_Zone,
        TotalArea: data.TotalArea
      };

        const response = await ApiService.axiosApi(`/dzone/${Id}`, {
        method: 'PUT',
        data: updateData
      });

      if (response.success) {
        toast.success("Distributary updated successfully");
        navigate(-1);
      } else {
        toast.error(response.data.message || "Failed to update distributary");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to update distributary");
    }
  };

  return (
    <>
      <Update
       title = {updateDistributaryTitle}
       parentTitle={distributaryZone}
       
       fields ={
        [
          {
             name : "Distributary_Zone",
             label : "Distributary Zone",
             type : "text"
          },
          {
            name : "TotalArea",
            label : "Toatal Area",
            type : "text"
          }
        ]
       }
       onSubmit = {onSubmit}
       initialData = {initialData}
       />

       
    </>
  );
};

export default UpdateDistributary;